var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedPlaylistsbgelement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223,416c-2.22-68.5-24-126.21-89.12-159.71-7.2-3.7-15.31-5.82-15.45-16.25-.11-8,3.77-13.34,11-14.69,84.37-15.72,106.24-86.48,134.13-151.93,1.58-3.7,1.63-8.16,3.61-11.55,4-6.77,8.11-16.27,17.61-13,8.43,2.94,9.09,12,7.71,20.61-3,18.61-7.38,37.19-8.17,55.91-2.31,54.85,25.94,91.48,73.17,115,9.78,4.87,23.27,7.63,24,18.91.75,12-14.11,15-22.79,19.95-55.63,31.87-91.14,78.64-108.33,140.17-3.51,12.54,1.07,35.64-20.07,31.86C212.89,448.21,222.59,428.86,223,416Zm21.13-63.67c17.67-21.76,30-43.56,48.16-57.74,28.22-22,45.46-36.91,5-65.5-19.41-13.73-29.63-40.47-44-61.31-21.08,18.11-33.23,44.68-57.47,59.9-19.37,12.16-17.46,24.18-1.54,39.73C216.59,289.2,230.85,316.8,244.15,352.36Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedPlaylistsbgelement);
export default __webpack_public_path__ + "static/media/Featured Playlists bg element.7bb4bc313e7b847bf3cecb7c21bd533e.svg";
export { ForwardRef as ReactComponent };